import { FileDto } from '../components/uploade';
import request from './request';

export interface QuestionnaireReq {
  uid: string;
  name: string;
  orderNo: string;
  mark: number;
  badAttitude?: number;
  arbitraryCharge?: number;
  untimelyHandling?: number;
  considerOtherBrands?: number;
  functionalImperfection?: number;
  noFixedParkingSpace?: number;
  theCostOfAdditionalItemsIsHigh?: number;
  customerServiceReplyIsNotTimely?: number;
  poorCustomerServiceAttitude?: number;
  refundReshoot?: number;
  negotiationTrouble?: number;
  dissatisfyOptions?: number[];
  other?: number;
  info?: string;
}

export interface AfterSalePreInfo {
  contactName?: string; //联系人姓名
  contactPhone?: string; //联系人电话
  province?: string; //省
  provinceCode?: string;
  city?: string; //市
  cityCode?: string;
  district?: string; //区
  districtCode?: string;
  address?: string; //地址

  uid?: string; //小鹏App登陆用户uid
  name?: string; //小鹏App登陆用户用户名
  privatePileNo?: string; //桩编号
  pileLightStatus?: number; //充电桩指示灯显示情况， 0-未填写，1-绿灯常亮，2-绿灯流水状，3-绿灯闪烁，4-黄灯闪烁，5-红灯闪烁，6-指示灯灭，7-不同颜色闪烁，20-其他情况
  problemType?: number; //问题类型，0-未填写，1-车锁枪，2-充电时间长、充电慢，3-充电中断，4-定时充电故障，5-家充桩外观损坏，6-无法启动充电，7-APP绑定家充失败，8-APP操作类故障，9-施工线路故障，10-充电桩迁移，20-退订拆装，21-巡检，22-专项，99-其他问题
  problemDesc?: string; //问题描述
  problemPicture?: FileDto[]; //现场照片，ossPath数组
}

export interface TokenDto {
  pathPrefix?: string; //路径
  accessKeyId?: string; //sts临时账号访问标识
  accessKeySecret?: string; //sts临时账号访问密钥
  stsToken?: string; //sts 访问令牌
  expiration?: string; //过期时间
  region?: string;
  bucket?: string;
  fileName?: string; //改写后的文件名
}

export interface AreaList {
  regionCode?: string; //行政区编码
  regionName?: string; //行政区名称
  regionLevel?: number; //行政区级别，1 省，2 市
  regionTier?: number; //行政区分级，1 一线，2 二线，3 三线，4 四线，5 五线
  regionType?: number; //行政区类型，1 A，2 B，3 C，4 D，5 E
  childList?: AreaList[];
}

// 提交报装评价问卷
export function submitQuestionnaire(data: QuestionnaireReq) {
  return request<QuestionnaireReq, any>(
    '/v5/charge/privatePile/homecharge/submitQuestionnaire',
    data,
    'POST'
  );
}

// 自主报障页回显数据
export function getAfterSalePreInfo(data: { equipmentCode: string, uid?: string }) {
  return request<{ equipmentCode: string }, AfterSalePreInfo>(
    '/v5/charge/privatePile/homecharge/getAfterSalePreInfo',
    data,
    'GET'
  );
}

//自主报障页提交工单
export function createAfterSaleOrder(data: AfterSalePreInfo) {
  return request<AfterSalePreInfo, { orderNo: string }>(
    '/v5/charge/privatePile/homecharge/createAfterSaleOrder',
    data,
    'POST'
  );
}

//获取上传文件的Oss Token
export function getToken(data: { pathType: number; fileName: string }) {
  return request<{ pathType: number; fileName: string }, TokenDto>(
    '/v5/charge/thor/ops/oss/getToken',
    data,
    'POST'
  );
}

//C端根据省/市编码获取雷神平台区域表行政区信息
export function getRegionTree(data: { key: string }) {
  return request<{ key: string }, AreaList[]>(
    '/v5/charge/thor/base/getRegionTree',
    data,
    'GET'
  );
}

//根据桩编码判断是否在质保期内
export function queryWarrantyStatus(data: { pileNo: string, uid?: string }) {
  return request<{ pileNo: string }, any>(
    '/v5/charge/private-pile/queryWarrantyStatus',
    data,
    'GET'
  );
}


//根据uid查询桩编码
export function searchPileList(data: { uid: string }) {
  return request<{ uid: string }, any>(
    '/logan/private/pile/listPrivatePileInfoByUid',
    data,
    'GET'
  );
}

//首充问卷提交
export function saveFirstChargeQuestionInfo(data: any) {
  return request<any, any>(
    '/v5/charge/privatePile/homecharge/saveFirstChargeQuestionInfo',
    data,
    'POST'
  );
}


//校验首充问卷UID
export function validFirstChargeQuestionUid() {
  return request<any, any>(
    '/v5/charge/privatePile/homecharge/validFirstChargeQuestionUid',
    {},
    'GET'
  );
}

// 首充问卷详情
export function getFirstChargeQuestionDetail(data: { questionId: number }) {
  return request<{ questionId: number }, any>(
    '/v5/charge/privatePile/homecharge/getFirstChargeQuestionDetail',
    data,
    'GET'
  );
}
